import React, { useState, useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { useNavigate } from 'react-router-dom';
import WithdrawalForm from '../../components/shared/WithdrawalForm';
import { requestCommissionWithdrawal, getVendorWalletSummary } from '../../features/vendor/vendorWalletSlice';

const formatCurrency = (n) => new Intl.NumberFormat('en-IN', { style: 'currency', currency: 'INR', minimumFractionDigits: 0, maximumFractionDigits: 0 }).format(n || 0);

const VendorWithdraw = () => {
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const { totalCommissionEarned, loading } = useSelector((s) => s.vendorWallet);
  const [vendorId, setVendorId] = useState(null);

  useEffect(() => {
    const vd = localStorage.getItem('vendorData');
    if (!vd) { navigate('/vendor/login'); return; }
    try {
      const data = JSON.parse(vd);
      setVendorId(data._id);
      dispatch(getVendorWalletSummary(data._id));
    } catch {
      navigate('/vendor/login');
    }
  }, [dispatch, navigate]);

  const handleSubmit = async ({ amount, bankDetails }) => {
    if (!vendorId) return;
    await dispatch(requestCommissionWithdrawal({ vendorId, amount, bankDetails }));
    navigate('/vendor/wallet/history');
  };

  return (
    <div className="min-h-screen bg-gradient-to-br from-blue-50 via-indigo-50 to-purple-50">
      <div className="mx-auto max-w-3xl px-4 sm:px-6 lg:px-8 py-8">
        <div className="bg-white rounded-xl shadow-lg p-6 border border-gray-100 mb-6">
          <h1 className="text-2xl font-bold text-gray-900">Request Withdrawal</h1>
          <p className="text-sm text-gray-600 mt-1">Commission available: {formatCurrency(totalCommissionEarned || 0)}</p>
        </div>
        <WithdrawalForm
          minAmount={100}
          maxAmount={totalCommissionEarned || 0}
          pending={null}
          onSubmit={handleSubmit}
          submitLabel="Request Withdrawal"
        />
      </div>
    </div>
  );
};

export default VendorWithdraw;
